import BaseCard from '../components/Cards/BaseCard';

interface Props {
  id: string;
  appId: string;
  isEnabled: boolean;
  isFavorite?: boolean;
  description: string;
  name: string;
  iconColor: string;
  iconText: string;
  url: string;
  cdkuUrl?: string;
  onClick?: Function;
  onCdkUniversityClick?: Function;
  onOpenInNewTabClick?: Function;
  onFavoriteChange?: Function;
  isRestricted?: boolean;
  restrictedTooltipMsg?: string;
  showNewIndicator: boolean;
  openInNewTab?: boolean;
  isDefault?: boolean;
  onSetDefaultWorkflow?: (workflowId: string, workflowName: string, isDefault: boolean) => void;
  warningMessage?: string;
  requiredOS?: string[];
}
export default function WorkflowCard({
  id,
  appId,
  isFavorite,
  isEnabled,
  description,
  name,
  iconText,
  iconColor,
  cdkuUrl,
  url,
  onClick,
  onCdkUniversityClick,
  onOpenInNewTabClick,
  onFavoriteChange,
  isRestricted,
  restrictedTooltipMsg,
  showNewIndicator,
  openInNewTab,
  isDefault = false,
  onSetDefaultWorkflow,
  warningMessage,
  requiredOS,
}: Props) {
  const showStartup = !!url && url.startsWith('http');

  const onOpenNewTabClick = (id:string,name:string, url:string) =>{
    onOpenInNewTabClick && onOpenInNewTabClick(appId,id,name,url)
  }

  const onCardClick = (item:any) =>{
    onClick && onClick(appId,item)
  }

  const onCdkUClick = (id:string,name:string) =>{
    onCdkUniversityClick && onCdkUniversityClick(appId,id,name)
  }

  const onFavChange = (id:string,name:string,isFavorite:boolean) =>{
    onFavoriteChange && onFavoriteChange(appId,id,name,isFavorite);
  }

  return (
    <BaseCard
      id={id}
      isIconRequired={false}
      isFavorite={isFavorite}
      isEnabled={isEnabled}
      description={description}
      learnMoreDescription={description}
      name={name}
      iconText={iconText}
      iconColor={iconColor}
      cdkuUrl={cdkuUrl}
      url={url}
      onClick={onCardClick}
      onCdkUniversityClick={onCdkUClick}
      onOpenInNewTabClick={onOpenNewTabClick}
      onFavoriteChange={onFavChange}
      isRestricted={isRestricted}
      restrictedTooltipMsg={restrictedTooltipMsg}
      showNewIndicator={showNewIndicator}
      openInNewTab={openInNewTab}
      showStartupOption={showStartup}
      isDefault={isDefault}
      onSetDefault={onSetDefaultWorkflow}
      warningMessage={warningMessage}
      requiredOS={requiredOS}
    />
  );
}